import { Provider } from '@angular/core';

import { ENTITY_FORM_SERVICES } from './entityFormServices';
import { EntityFormServiceProvider } from './datasource/entity-form-service-provider.service';

export const ENTITY_FORM_PROVIDER: Provider[] = [
  { provide: 'EntityFormServices', useValue: ENTITY_FORM_SERVICES },
  EntityFormServiceProvider,
];
